import { useNavigate } from "react-router-dom";

import { MainLayout } from "~/layout";
import { ROUTES } from "~/router/routes";
import { ArrowIcon } from "~/shared/components/icons/ArrowIcon";
import { CheckIcon } from "~/shared/components/icons/CheckIcon";
import { FormContentContainer } from "../components/SignUp";

export const EligibilitySuccessScreen = () => {
  const navigate = useNavigate();

  return (
    <MainLayout>
      <FormContentContainer className="rounded-lg shadow-xl">
        <CheckIcon className="mb-4 size-16 self-center" />
        <div className="flex flex-col items-center text-center">
          <h1 className="font-display mb-2 text-xl">
            Great news, your care is covered!
          </h1>
          <p className="mb-12 text-gray-600">
            Your copay will vary based on your plan specifics. A team member
            will follow up within 24 business hours to provide more details on
            your out of pocket cost.
          </p>
          <button
            className="flex cursor-pointer items-center justify-end gap-2 rounded-xl bg-green-300 px-6 py-4 font-medium"
            onClick={() => {
              navigate(ROUTES.providerSelection);
            }}
          >
            <span>NEXT</span>
            <ArrowIcon direction="left" />
          </button>
        </div>
      </FormContentContainer>
    </MainLayout>
  );
};
